(function () {

	var instance = null;
	var NativeInteractions = function () {
		if (instance) {
			return instance;
		}

		instance = this;
		this.orientationChangedCallbacks = $.Callbacks();

		this.pushNotificationEnabled = false;
		// on dom ready bind events and cache elements
		$($.proxy(this.init, this));
	};

	NativeInteractions.NATIVE_BACK_URL = "tdwebmodule://mod/back";
	NativeInteractions.NATIVE_BUY_SELL_CALL_URL = "tdwebmodule://mod/quote";
	NativeInteractions.NATIVE_WATCHLIST_URL = "tdwebmodule://mod/watchlist";
	NativeInteractions.NATIVE_LOGOUT_URL = "tdwebmodule://mod/logout";
	NativeInteractions.NATIVE_PUSH_NOTIFICATIONS_URL = "tdwebmodule://mod/profile&preference";
	NativeInteractions.NATIVE_GET_PUSH_NOTIFICATIONS_STATUS_URL = "tdwebmodule://mod/DeviceSettings?settings=pushNotificationSettings";
	NativeInteractions.NATIVE_GET_LOCATION_STATUS_URL = "tdwebmodule://mod/DeviceSettings?settings=locationSettings";
	NativeInteractions.NATIVE_OPEN_ADVANCED_CHART = "tdwebmodule://mod/advchart?ORIENTATION=LANDSCAPE";
	NativeInteractions.NATIVE_CLOSE_ADVANCED_CHART = "tdwebmodule://mod/advchart?ORIENTATION=PORTRAIT";

	NativeInteractions.prototype.init = function () {
		this.cacheElements();
		this.bindEvents();
		this.setPageFocus();
	};

	NativeInteractions.prototype.cacheElements = function () {
		this.$backButton = $("#BackButton");
		this.$logoutLink = $("#LogoutLink");
		this.$buySellCallButtons = $("button.btn-buy-sell-call");
		this.$addToWatchlistButton = $("button.add-to-td-watchlist");
		this.mobileLoader = new MobileLoader();
		this.$anchorItems = $("#WSOD a").not(".ign-ldr");
		// needed for hacks to deal with resize and zoom on input focus
		this.$metaView = $('meta[name=viewport]');
	};

	NativeInteractions.prototype.bindEvents = function () {
		this.$buySellCallButtons.on("click.native-interaction", $.proxy(this.handleBuySellCall, this));
		this.$addToWatchlistButton.on("click.native-interaction", $.proxy(this.handleWatchlistCall, this));
		this.$backButton.on("click.native-interaction", $.proxy(this.goBack, this));
		this.$logoutLink.on("click.native-interaction", $.proxy(this.logout, this));
		var _self = this;

		if (this.$anchorItems.length > 0) {
			this.$anchorItems.on("click", function (oEvent) {
				if (typeof _self.mobileLoader !== 'undefined' && !$(oEvent.currentTarget).parent().hasClass('active')) {
					_self.mobileLoader.show();
				}
			});
		}

		$(document).ready(function () {
			_self.mobileLoader.hide();
			_self.triggerOrientation();
		});

		window.onpageshow = function () {
			_self.mobileLoader.hide();
		};
	};

	NativeInteractions.prototype.resetMetaView = function () {
		/// <summary>
		///     handles resetting the device viewport so as to prevent iOS input focus zooming and
		/// </summary>
		this.$metaView.attr('content', 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1');

		setTimeout($.proxy(function () {
			this.$metaView.attr('content', 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=2');
		}, this), 1000);
	};

	NativeInteractions.prototype._getScreenWidth = function () {

		if ($('#android').length > 0) {
			return Math.max(screen.width, document.documentElement.clientWidth);
		}

		return Math.max(window.innerWidth, document.documentElement.clientWidth);
	};

	NativeInteractions.prototype._getScreenHeight = function () {

		if ($('#android').length > 0) {
			return Math.max(screen.height, document.documentElement.clientHeight);
		}

		return Math.max(window.innerHeight, document.documentElement.clientHeight);
	};

	NativeInteractions.prototype._getCurrentOrientation = function () {

		var width = this._getScreenWidth();
		var height = this._getScreenHeight();
		var orientation = "P";

		if (width > height) {
			orientation = "L";
		}

		return orientation;
	};

	NativeInteractions.prototype.triggerOrientation = function () {
		if (this.orientTimeout) {
			try {
				window.clearTimeout(this.orientTimeout);
			} catch (e) {
			}
		}

		var orientation = this._getCurrentOrientation();
		this.storeScreenDimensions('triggerOrientation from NativeInteractions');
		this.orientationChangedCallbacks.fire(orientation);

		this.listenForOrientationChanged();
	};

	NativeInteractions.prototype.storeScreenDimensions = function () {
		/// <summary>
		///     We have to check screen.width and window.innerWidth because on some devices one will be null while the other isn't.
		///     Although, they should never both end up null
		///     This method stores the dimensions as they should be for portrait mode hence the global var names pWidth and pHeight
		/// </summary>
		var width = this._getScreenWidth();
		var height = this._getScreenHeight();

		this.pHeight = height;
		this.pWidth = width;
	};

	NativeInteractions.prototype.logout = function (e) {
		window.location = NativeInteractions.NATIVE_LOGOUT_URL;
	};

	NativeInteractions.prototype.toggleAdvancedChart = function(openAdvancedChart) {
		if (openAdvancedChart) {
			window.location = NativeInteractions.NATIVE_OPEN_ADVANCED_CHART;
		} else {
			window.location = NativeInteractions.NATIVE_CLOSE_ADVANCED_CHART;
		}
	};

	NativeInteractions.prototype.handleBuySellCall = function (e) {
		var $button = $(e.currentTarget) || $(e.target);
		var params = {
			SYMBOL: $button.data("symbol"),
			MARKET: $button.data("market"),
			ACTION: $button.data("action"),
			SECURITY_TYPE: $button.data("security"),
			UUID: $button.data("uuid")
		};

		if ($button.data("strike-price")) {
			params["PRICE"] = $button.data("strike-price");
		}

		window.location = NativeInteractions.NATIVE_BUY_SELL_CALL_URL + "?" + $.param(params);
	};

	NativeInteractions.prototype.handleWatchlistCall = function (e) {
		var $button = $(e.currentTarget);

		window.location = NativeInteractions.NATIVE_WATCHLIST_URL + "?" + $.param({
			SYMBOL: $button.data("symbol"),
			MARKET: $button.data("market"),
			SECURITY_TYPE: $button.data("security")
		});
	};

	NativeInteractions.prototype.goBack = function (e) {
		this.mobileLoader.show();
		var _self = this;
		var $backButton = $(e.currentTarget);

		if (document.referrer && !$backButton.hasClass('back-to-app') && window.history.length !== 1) {
			window.history.back();

			// TDWM-1054
			// this timeout will ensure that if the browser back function failed the native back function will be called.
			window.setTimeout(function () {
				window.location = NativeInteractions.NATIVE_BACK_URL;
			}, 10000);
		} else {
			window.location = NativeInteractions.NATIVE_BACK_URL;
		}
	};

	// listenForOrientationChanged has been set in place to detect an orientation when it happens, 
	// instead of going off of when we're told it happens.
	NativeInteractions.prototype.orientationChanged = function (sOrientation) {
		if (console && console.log) {
			console.log('Application fired orientation change');
		}
	};

	NativeInteractions.prototype.listenForOrientationChanged = function () {
		var self = this;

		if (!window.WSOD.OrientationChangedListener) {
			window.WSOD.OrientationChangedListener = window.setInterval(function () {
				if (self.pWidth != self._getScreenWidth()) {
					var orientation = self._getCurrentOrientation();
					self.storeScreenDimensions();
					self.orientationChangedCallbacks.fire(orientation);
				}
			}, 250);
		}
	};

	// TDCA-674, this feature is for accessibility
	// TDWM-1190 adjusting the timeout to focus the header right away
	NativeInteractions.prototype.setPageFocus = function () {
		window.setTimeout(function () {
			$('.focus-header').focus();
		}, 100);
	};

	NativeInteractions.prototype.goToPushNotificationsSettings = function () {
		window.location = NativeInteractions.NATIVE_PUSH_NOTIFICATIONS_URL;
	};
	// We call this method to tell the native app to update us about the push notification settings.
	NativeInteractions.prototype.getPushNotificationsStatus = function () {
		window.location = NativeInteractions.NATIVE_GET_PUSH_NOTIFICATIONS_STATUS_URL;
	};
	// We call this method to tell the native app to update us about the location status
	NativeInteractions.prototype.getLocationStatus = function () {
		window.location = NativeInteractions.NATIVE_GET_LOCATION_STATUS_URL;
	};

	// Method for TD to fire when we request tdwebmodule://mod/DeviceSettings?settings=pushNoficationSettings
	NativeInteractions.prototype.modPushNotificationsEnabled = function(isPushEnabled) {
		if (typeof isPushEnabled != 'undefined') {
			//Extra error handling incase their devs pass 1 or 0 or true false or 'true' 'false' or 'True' 'False'
			if (typeof isPushEnabled == 'number') {
				this.pushNotificationEnabled = isPushEnabled === 1;
			}
			if (typeof isPushEnabled == 'boolean') {
				this.pushNotificationEnabled = isPushEnabled;
			}
			if (typeof isPushEnabled == 'string') {
				this.pushNotificationEnabled = isPushEnabled.toLowerCase() === 'true';
			}
		}
		window.dispatchEvent(new CustomEvent('pushNotificationUpdate', { bubbles: true, cancelable: true }));
	};

	// Method for TD to fire when we request tdwebmodule://mod/DeviceSettings?settings=locationSettings
	NativeInteractions.prototype.modLocationSettings = function (location) {
		if (console && console.log) {
			console.log('modLocationSettings, Not implemented yet');
			console.log('Location settings called from native app with location:');
			console.log(location);
		}
	};


	window.nativeInteractions = new NativeInteractions();
})();